export default class SlickOptions {
    getDefault(arrows = false, variableWidth = true) {
        return {
            infinite: true,
            arrows: arrows,
            dots: true,
            variableWidth: variableWidth,
        };
    }

    getDefaultFeatured(arrows = false) {
        return {
            infinite: true,
            arrows: arrows,
            dots: true,
            variableWidth: true,
        };
    }

    getCustomDefault(arrows = false) {
        return {
            infinite: true,
            arrows: arrows,
            dots: true,
            variableWidth: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        }
    }

    getCustomDefaultGraphs(arrows = false) {
        return {
            infinite: true,
            arrows: arrows,
            dots: true,
            variableWidth: true,
            centerMode: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [{
                    breakpoint: 1279,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        centerMode: true,
                    }
                }
            ]
        }
    }

    getCustomDefaultProducts(arrows = false) {
        return {
            infinite: true,
            arrows: arrows,
            dots: true,
            variableWidth: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }]
        }
    }

    getCustomDefaultLites(arrows = false) {
        return {
            infinite: true,
            arrows: arrows,
            dots: false,
            variableWidth: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '0',
            responsive: [{
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        }
    }

    getCustom() {
        return {
            infinite: true,
            arrows: false,
            dots: true,
            autoplay: false
        };
    }

    getCustomWithArrows() {
        return {
            infinite: true,
            arrows: true,
            dots: true,
            autoplay: false
        };
    }

    getSimpleGallery() {
        return {
            infinite: false,
            arrows: false,
            dots: false,
            variableWidth: true,
            responsive: [{
                breakpoint: 768,
                settings: {
                    variableWidth: false,
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            }]
        }
    }

    getGallery() {
        return {
            infinite: false,
            arrows: false,
            dots: false,
            slidesToShow: 5,
            slidesToScroll: 5,
            responsive: [{
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                    }
                }
            ]
        }
    }

    getCustomGallery(asNavFor = false) {
        return {
            infinite: false,
            arrows: false,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: asNavFor,
            swipe: false,
        }
    }

    getCustomGalleryNav(asNavFor = false) {
        return {
            infinite: false,
            arrows: false,
            dots: false,
            slidesToShow: 5,
            slidesToScroll: 5,
            asNavFor: asNavFor,
            focusOnSelect: true,
            variableWidth: true,
            responsive: [{
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        variableWidth: false,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        focusOnSelect: false,
                        variableWidth: false,
                    }
                }
            ]
        }
    }

    getSimpleFull() {
        return {
            infinite: true,
            arrows: false,
            dots: true
        }
    }

    getResponsive() {
        return {
            infinite: true,
            arrows: true,
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        };
    }

    getAssertive(arrows = false) {
        return {
            infinite: true,
            arrows: arrows,
            dots: true,
            variableWidth: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [{
                breakpoint: 768,
                settings: 'unslick'
            }]
        };
    }

    getSimple() {
        return {
            dots: true,
            arrows: false
        }
    }
}


// WEBPACK FOOTER //
// ./resources/site/js/providers/slick.js